import { FormControl, FormHelperText } from '@material-ui/core'

import { ButtonProps } from 'components/inputs/Button/Button'

import * as Styled from './UploadFilesField.styles'

interface UploadFilesFieldProps extends ButtonProps {
  className?: string
  onFilesChange: (file: File[]) => void
  error?: boolean
  errorMessage?: string
  touched?: boolean
  multiple?: boolean
  disabled?: boolean
}

const UploadImageField = ({
  onFilesChange,
  className,
  error,
  errorMessage,
  touched,
  multiple = false,
  disabled = false,
}: UploadFilesFieldProps): JSX.Element => (
  <FormControl error={error && touched} className={className}>
    {error && touched && (
    <FormHelperText color='error'>
      {errorMessage}
    </FormHelperText>
    )}
    <Styled.UploadFilesButton
      onFilesChange={onFilesChange}
      multiple={multiple}
      disabled={disabled}
    />
  </FormControl>
)

export { UploadImageField }
